import React, { useState, useEffect } from "react";
import {
  Typography,
  Container,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Avatar,
  OutlinedInput,
  Checkbox,
  Snackbar,
  Alert,
  MenuItem,
  ListItemText,
  Card,
  CardContent,
  TablePagination,
} from "@mui/material";
import SpeedMeetingChatDialog from "../SpeedMeetingChatDialog";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from "@mui/icons-material/Share";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CommentIcon from "@mui/icons-material/Comment";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import Footer from '../Materials/Footer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import BurgerBar from '../Materials/BurgerBar';

export default function ListSpeedMeetings() {
  const { user } = useAuth();
  const [speedMeetings, setSpeedMeetings] = useState([]);
  const [receivedSpeedMeetings, setReceivedSpeedMeetings] = useState([]);
  const [speedMeetingStates, setSpeedMeetingStates] = useState([]);
  const [users, setUsers] = useState([]);
  const [invitedUsersMap, setInvitedUsersMap] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [speedMeetingToDelete, setSpeedMeetingToDelete] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [speedMeetingToEdit, setSpeedMeetingToEdit] = useState(null);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [speedMeetingToShare, setSpeedMeetingToShare] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [speedMeetingToView, setSpeedMeetingToView] = useState(null);
  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);
const [speedMeetingForComments, setSpeedMeetingForComments] = useState(null);
  const [selectedUserEmails, setSelectedUserEmails] = useState([]);
  const [existingInvites, setExistingInvites] = useState([]);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [meetingToCancel, setMeetingToCancel] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const navigate = useNavigate();

  // Estados para paginação das tabelas
  const [myPage, setMyPage] = useState(0);
  const [myRowsPerPage, setMyRowsPerPage] = useState(5);
  const [receivedPage, setReceivedPage] = useState(0);
  const [receivedRowsPerPage, setReceivedRowsPerPage] = useState(5);
  

  useEffect(() => {
    if (user) {
      fetchSpeedMeetings(user.userId);
      fetchReceivedSpeedMeetings(user.userId);
      fetchSpeedMeetingStates();
      fetchAllUsers();
    }
  }, [user]);

  useEffect(() => {
    if (speedMeetings.length > 0 && users.length > 0) {
      fetchInvitedUsers();
    }
  }, [speedMeetings, users]);


// Função para formatar a data para o input datetime-local
const formatDateTimeForInput = (dateString) => {
  if (!dateString) return '';
  
  // Se já vem no formato correto do backend
  if (dateString.includes('T')) {
    return dateString.slice(0, 16); // Pega apenas a parte da data e hora
  }
  
  // Se vier como string ISO (fallback)
  const date = new Date(dateString);
  const pad = num => num.toString().padStart(2, '0');
  
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// Ao enviar para o backend, converter para UTC
const prepareDateForBackend = (localDateString) => {
  if (!localDateString) return null;
  
  // Cria objeto Date a partir da string local
  const localDate = new Date(localDateString);
  
  // Formata como string ISO sem informação de timezone
  const pad = num => num.toString().padStart(2, '0');
  return `${localDate.getFullYear()}-${pad(localDate.getMonth() + 1)}-${pad(localDate.getDate())} ${pad(localDate.getHours())}:${pad(localDate.getMinutes())}:00`;
};

  const fetchSpeedMeetings = async (userId) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/user/${userId}`);
      if (response.ok) {
        const data = await response.json();
        setSpeedMeetings(data);
      }
    } catch (error) {
      console.error("Error fetching speed meetings:", error);
    }
  };

  const fetchReceivedSpeedMeetings = async (userId) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/user-speedmeetings/user/${userId}`);
      if (response.ok) {
        const userSpeedMeetings = await response.json();

        const meetings = [];
        for (const item of userSpeedMeetings) {
          const meetingResponse = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${item.speedmeeting_id}`);
          if (meetingResponse.ok) {
            const meetingData = await meetingResponse.json();
            meetings.push(meetingData);
          }
        }

        setReceivedSpeedMeetings(meetings);
      }
    } catch (error) {
      console.error("Error fetching received speed meetings:", error);
    }
  };

  const fetchSpeedMeetingStates = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/speedmeeting-states');
      if (response.ok) {
        const data = await response.json();
        setSpeedMeetingStates(data);
      }
    } catch (error) {
      console.error('Error fetching speed meeting states:', error);
    }
  };

  const fetchAllUsers = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/users');
      if (response.ok) {
        const data = await response.json();
        setUsers(data);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const fetchInvitedUsers = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/users-speedmeetings');
      if (response.ok) {
        const allRelations = await response.json();
        const newInvitedUsersMap = {};

        for (const meeting of speedMeetings) {
          const meetingRelations = allRelations.filter(
            relation => relation.speedmeeting_id === meeting.id
          );

          const emails = [];
          for (const relation of meetingRelations) {
            const user = users.find(u => u.id === relation.user_id);
            if (user) emails.push(user.email);
          }

          newInvitedUsersMap[meeting.id] = emails;
        }

        setInvitedUsersMap(newInvitedUsersMap);
      }
    } catch (error) {
      console.error('Error fetching invited users:', error);
    }
  };

  const fetchExistingInvites = async (speedmeetingId) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeeting-users/${speedmeetingId}/users`);
      if (response.ok) {
        const data = await response.json();
        setExistingInvites(data);

        // Set initially selected users
        const invitedUserIds = data.map(invite => invite.user_id);
        const invitedUsers = users.filter(user => invitedUserIds.includes(user.id));
        setSelectedUserEmails(invitedUsers.map(user => user.email));
      }
    } catch (error) {
      console.error('Error fetching existing invites:', error);
    }
  };

  const getStatusProps = (stateName) => {
    if (!stateName) return { color: 'default', icon: null, label: 'Unknown' };

    const lowerCaseState = stateName.toLowerCase();

    if (lowerCaseState.includes('por agendar')) {
      return { color: 'default', icon: <ScheduleIcon />, label: 'To be scheduled' };
    } else if (lowerCaseState.includes('agendada mas ainda não realizada')) {
      return { color: 'warning', icon: <ScheduleIcon />, label: 'Scheduled (pending)' };
    } else if (lowerCaseState.includes('agendada e realizada')) {
      return { color: 'success', icon: <CheckCircleIcon />, label: 'Done' };
    } else if (lowerCaseState.includes('processo concluído')) {
      return { color: 'secondary', icon: <DoneAllIcon />, label: 'Completed' };
    } else if (lowerCaseState.includes('cancelado')) {
      return { color: 'error', icon: <CloseIcon />, label: 'Cancel' };
    }

    return { color: 'default', icon: null, label: stateName };
  };

  const handleCancelMeeting = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${id}/set-specific-state`, {
        method: 'PATCH',
      });

      if (response.ok) {
        const updatedMeeting = await response.json();

        // Update the meeting in state
        setSpeedMeetings(speedMeetings.map(meeting =>
          meeting.id === updatedMeeting.id ? updatedMeeting : meeting
        ));

        showSnackbar('Meeting canceled successfully!', 'success');
      }
    } catch (error) {
      console.error('Error canceling meeting:', error);
      showSnackbar('Error canceling meeting', 'error');
    }
  };

  const handleOpenCancelDialog = (id) => {
    const meeting = speedMeetings.find(m => m.id === id);
    setMeetingToCancel(meeting);
    setOpenCancelDialog(true);
  };

  const handleCloseCancelDialog = () => {
    setOpenCancelDialog(false);
    setMeetingToCancel(null);
  };

  const handleConfirmCancel = async () => {
    if (meetingToCancel) {
      await handleCancelMeeting(meetingToCancel.id);
      setOpenCancelDialog(false);
      setMeetingToCancel(null);
    }
  };

  const handleOpenDeleteDialog = (id) => {
    const meeting = speedMeetings.find((meeting) => meeting.id === id);
    setSpeedMeetingToDelete(meeting);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSpeedMeetingToDelete(null);
  };
 

  const handleConfirmDelete = async () => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${speedMeetingToDelete.id}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        setSpeedMeetings(speedMeetings.filter((meeting) => meeting.id !== speedMeetingToDelete.id));
        setOpenDeleteDialog(false);
        setSpeedMeetingToDelete(null);
        showSnackbar('Speed meeting deleted successfully!', 'success');
      }
    } catch (error) {
      console.error("Error deleting speed meeting:", error);
      showSnackbar('Error deleting speed meeting', 'error');
    }
  };

  const handleOpenEditDialog = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${id}`);
      if (response.ok) {
        const data = await response.json();

        setSpeedMeetingToEdit({
          ...data,
          date: data.date,
          end_date: data.end_date,
        });
        setOpenEditDialog(true);
      }
    } catch (error) {
      console.error('Error fetching speed meeting:', error);
      showSnackbar('Error fetching speed meeting', 'error');
    }
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSpeedMeetingToEdit(null);
  };

  const handleSaveEdit = async () => {
    try {
      const updatedMeeting = {
        subject: speedMeetingToEdit.subject,
        description: speedMeetingToEdit.description,
        contact: speedMeetingToEdit.contact,
        date: speedMeetingToEdit.date,
        end_date: speedMeetingToEdit.end_date,
      };

      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${speedMeetingToEdit.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedMeeting),
      });

      if (response.ok) {
        const savedMeeting = await response.json();
        setSpeedMeetings(speedMeetings.map((meeting) => (meeting.id === savedMeeting.id ? savedMeeting : meeting)));
        setOpenEditDialog(false);
        setSpeedMeetingToEdit(null);
        showSnackbar('Speed meeting updated successfully!', 'success');
      }
    } catch (error) {
      console.error("Error updating speed meeting:", error);
      showSnackbar('Error updating speed meeting', 'error');
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setSpeedMeetingToEdit({ ...speedMeetingToEdit, [name]: value });
  };

  const handleOpenShareDialog = async (id) => {
    setSpeedMeetingToShare(id);
    await fetchExistingInvites(id);
    setOpenShareDialog(true);
  };

  const handleCloseShareDialog = () => {
    setOpenShareDialog(false);
    setSpeedMeetingToShare(null);
    setSelectedUserEmails([]);
  };

  const handleShareInvites = async () => {
  try {
    const selectedUsers = users.filter(user => selectedUserEmails.includes(user.email));
    const currentInvites = existingInvites.map(invite => invite.user_id);

    // Users to add (newly selected)
    const usersToAdd = selectedUsers.filter(user => !currentInvites.includes(user.id));
    const usersToAddIds = usersToAdd.map(user => user.id);

    // Users to remove (deselected)
    const usersToRemove = existingInvites.filter(invite =>
      !selectedUserEmails.includes(users.find(u => u.id === invite.user_id)?.email)
    );

    // 1. Primeiro atualizamos os convites no banco de dados
    let addedCount = 0;
    for (const user of usersToAdd) {
      const response = await fetch('https://api.hub4food.colab4food.com/api/users-speedmeetings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: user.id,
          speedmeeting_id: speedMeetingToShare
        }),
      });

      if (response.ok) {
        addedCount++;
      } else {
        showSnackbar(`Failed to invite ${user.email}`, 'error');
      }
    }

    // Remover convites deselecionados
    let removedCount = 0;
    for (const invite of usersToRemove) {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/users-speedmeetings/${invite.user_id}/${speedMeetingToShare}`,
        {
          method: 'DELETE',
        }
      );

      if (response.ok) {
        removedCount++;
      } else {
        showSnackbar(`Failed to remove invite for ${users.find(u => u.id === invite.user_id)?.email || 'user'}`, 'error');
      }
    }

    // 2. Enviar emails apenas para os novos usuários adicionados
    if (usersToAdd.length > 0) {
      try {
        const emailResponse = await fetch('https://api.hub4food.colab4food.com/api/send-bulk-invites', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            speedmeetingId: speedMeetingToShare,
            userIds: usersToAddIds
          }),
        });

        if (!emailResponse.ok) {
          throw new Error('Failed to send invitation emails');
        }

        showSnackbar(`Emails de convite enviados para ${usersToAdd.length} participantes`, 'success');
      } catch (emailError) {
        console.error('Error sending invitation emails:', emailError);
        showSnackbar('Convites salvos, mas erro ao enviar emails', 'warning');
      }
    }

    if (addedCount > 0 || removedCount > 0) {
      showSnackbar(
        `Convites atualizados! Adicionados ${addedCount}, removidos ${removedCount}.`,
        'success'
      );
      await fetchExistingInvites(speedMeetingToShare);
      await fetchInvitedUsers();
    } else {
      showSnackbar('Nenhuma alteração para salvar', 'info');
    }

    handleCloseShareDialog();
  } catch (error) {
    console.error('Error sharing speed meeting:', error);
    showSnackbar('Erro ao compartilhar speed meeting', 'error');
  }
};

  const handleUserSelection = (event) => {
    const { target: { value } } = event;
    setSelectedUserEmails(typeof value === 'string' ? value.split(',') : value);
  };

  const handleOpenViewDialog = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${id}`);
      if (response.ok) {
        const data = await response.json();
        setSpeedMeetingToView(data);
        setOpenViewDialog(true);
      }
    } catch (error) {
      console.error('Error fetching speed meeting:', error);
      showSnackbar('Error fetching speed meeting', 'error');
    }
  };

  const handleCloseViewDialog = () => {
    setOpenViewDialog(false);
    setSpeedMeetingToView(null);
  };

  const handleOpenCommentsDialog = (meeting) => {
  setSpeedMeetingForComments(meeting);
  setOpenCommentsDialog(true);
};


 

 

 const handleCloseCommentsDialog = () => {
  setOpenCommentsDialog(false);
  setSpeedMeetingForComments(null);
};

 
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const isAlreadyInvited = (email) => {
    const user = users.find(u => u.email === email);
    if (!user) return false;
    return existingInvites.some(invite => invite.user_id === user.id);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <BurgerBar />

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        {/* My Speed Meetings Card */}
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              My Speed Meetings
            </Typography>

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              sx={{ mt: 2, mb: 2 }}
              onClick={() => navigate("/createSpeedMeeting")}
            >
              New Speed Meeting
            </Button>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Subject</TableCell>
                    <TableCell align="center">Sent For</TableCell>
                    <TableCell align="center">Contact</TableCell>
                    <TableCell align="center">State</TableCell>
                    <TableCell align="center">Date</TableCell>
                    <TableCell align="center">Actions</TableCell>
                    <TableCell align="center">Options</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {speedMeetings
                    .slice(
                      myPage * myRowsPerPage,
                      myPage * myRowsPerPage + myRowsPerPage
                    )
                    .map((meeting) => {
                      const state = speedMeetingStates.find(
                        state => state.id === meeting.speedmeeting_state_id
                      );

                      const statusProps = getStatusProps(state?.state_name);
                      const invitedEmails = invitedUsersMap[meeting.id] || [];
                      const isCanceled = state?.state_name.toLowerCase().includes('cancelado');

                      return (
                        <TableRow key={meeting.id}>
                          <TableCell align="center">
                            {meeting.subject}
                          </TableCell>

                          <TableCell align="center">
                            {invitedEmails.length > 0 ? (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {invitedEmails.map((email, index) => (
                                  <Chip
                                    key={index}
                                    label={email}
                                    size="small"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                No invites sent
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell align="center">
                            {meeting.contact}
                          </TableCell>

                          <TableCell align="center">
                            <Chip
                              avatar={<Avatar>{statusProps.icon}</Avatar>}
                              label={statusProps.label}
                              color={statusProps.color}
                              variant="outlined"
                              size="small"
                            />
                          </TableCell>

                          <TableCell align="center">
                            {new Date(meeting.date).toLocaleString('pt-PT', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              timeZone: 'UTC'
                            })}
                          </TableCell>

                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenEditDialog(meeting.id)}
                              >
                                <EditIcon />
                              </IconButton>

                              <IconButton
                                color="secondary"
                                onClick={() => handleOpenShareDialog(meeting.id)}
                              >
                                <ShareIcon />
                              </IconButton>

                              <IconButton
                                color="error"
                                onClick={() => handleOpenDeleteDialog(meeting.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Stack>
                          </TableCell>

                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <IconButton
                                color={meeting.user_comments ? "info" : "default"}
                                onClick={() => handleOpenCommentsDialog(meeting)}
                              >
                                <CommentIcon />
                              </IconButton>

                              {!isCanceled && (
                                <IconButton
                                  color="warning"
                                  onClick={() => handleOpenCancelDialog(meeting.id)}
                                >
                                  <CloseIcon />
                                </IconButton>
                              )}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 20]}
              component="div"
              count={speedMeetings.length}
              rowsPerPage={myRowsPerPage}
              page={myPage}
              onPageChange={(event, newPage) => setMyPage(newPage)}
              onRowsPerPageChange={(event) => {
                setMyRowsPerPage(parseInt(event.target.value, 10));
                setMyPage(0);
              }}
              labelRowsPerPage="Lines per page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
              }
            />
          </CardContent>
        </Card>

        {/* Received Speed Meetings Card */}
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Received Speed Meetings
            </Typography>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Subject</TableCell>
                    <TableCell align="center">Contact</TableCell>
                    <TableCell align="center">State</TableCell>
                    <TableCell align="center">Date</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {receivedSpeedMeetings
                    .slice(
                      receivedPage * receivedRowsPerPage,
                      receivedPage * receivedRowsPerPage + receivedRowsPerPage
                    )
                    .map((meeting) => {
                      const state = speedMeetingStates.find(
                        state => state.id === meeting.speedmeeting_state_id
                      );

                      const statusProps = getStatusProps(state?.state_name);

                      return (
                        <TableRow key={meeting.id}>
                          <TableCell align="center">
                            {meeting.subject}
                          </TableCell>

                          <TableCell align="center">
                            {meeting.contact}
                          </TableCell>

                          <TableCell align="center">
                            <Chip
                              avatar={<Avatar>{statusProps.icon}</Avatar>}
                              label={statusProps.label}
                              color={statusProps.color}
                              variant="outlined"
                              size="small"
                            />
                          </TableCell>

                          <TableCell align="center">
                            {new Date(meeting.date).toLocaleString('pt-PT', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              timeZone: 'UTC'
                            })}
                          </TableCell>

                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenViewDialog(meeting.id)}
                              >
                                <VisibilityIcon />
                              </IconButton>

                              <IconButton
                                color={meeting.user_comments ? "info" : "default"}
                                onClick={() => handleOpenCommentsDialog(meeting)}
                              >
                                <CommentIcon />
                              </IconButton>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 20]}
              component="div"
              count={receivedSpeedMeetings.length}
              rowsPerPage={receivedRowsPerPage}
              page={receivedPage}
              onPageChange={(event, newPage) => setReceivedPage(newPage)}
              onRowsPerPageChange={(event) => {
                setReceivedRowsPerPage(parseInt(event.target.value, 10));
                setReceivedPage(0);
              }}
              labelRowsPerPage="Lines per page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
              }
            />
          </CardContent>
        </Card>
      </Container>

      {/* Cancel Dialog */}
      <Dialog open={openCancelDialog} onClose={handleCloseCancelDialog}>
        <DialogTitle>Confirm Cancel</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to cancel "{meetingToCancel?.subject}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCancelDialog}>
            No
          </Button>
          <Button onClick={handleConfirmCancel} color="warning">
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Speed Meeting</DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete the speed meeting
            <strong> "{speedMeetingToDelete?.subject}"</strong>?
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Cancel
          </Button>

          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={openEditDialog} onClose={handleCloseEditDialog} fullWidth maxWidth="sm">
        <DialogTitle>Edit Speed Meeting</DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            label="Subject"
            name="subject"
            value={speedMeetingToEdit?.subject || ""}
            onChange={handleEditChange}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Description"
            name="description"
            value={speedMeetingToEdit?.description || ""}
            onChange={handleEditChange}
            margin="normal"
            multiline
            rows={4}
          />

          <FormControl fullWidth margin="normal">
            <InputLabel id="contact-method-label">
              Contact
            </InputLabel>

            <Select
              labelId="contact-method-label"
              id="contact-method"
              name="contact"
              value={speedMeetingToEdit?.contact || ''}
              label="Contact"
              onChange={handleEditChange}
              variant="outlined"
            >
              <MenuItem value="Email">Email</MenuItem>
              <MenuItem value="Telephone">Telephone</MenuItem>
              <MenuItem value="Teams">Teams</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Initial Date and Hour"
            name="date"
            type="datetime-local"
            value={
              speedMeetingToEdit?.date
                ? formatDateTimeForInput(speedMeetingToEdit.date)
                : ''
            }
            onChange={handleEditChange}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              step: 300
            }}
          />

          <TextField
            fullWidth
            label="End Date and Time"
            name="end_date"
            type="datetime-local"
            value={
              speedMeetingToEdit?.end_date
                ? formatDateTimeForInput(speedMeetingToEdit.end_date)
                : ''
            }
            onChange={handleEditChange}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="error">
            Cancel
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Share Dialog */}
      <Dialog open={openShareDialog} onClose={handleCloseShareDialog} fullWidth maxWidth="sm">
        <DialogTitle>Share Speed Meeting</DialogTitle>

        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Invite Users</InputLabel>

            <Select
              multiple
              value={selectedUserEmails}
              onChange={handleUserSelection}
              input={<OutlinedInput label="Invite Users" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((email) => (
                    <Chip
                      key={email}
                      label={email}
                      color={isAlreadyInvited(email) ? 'primary' : 'default'}
                    />
                  ))}
                </Box>
              )}
            >
              {users.map((user) => (
                <MenuItem key={user.email} value={user.email}>
                  <Checkbox checked={selectedUserEmails.includes(user.email)} />
                  <ListItemText primary={user.email} secondary={user.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseShareDialog} color="error">
            Cancel
          </Button>

          <Button onClick={handleShareInvites} color="primary">
            Update Invites
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Dialog */}
      <Dialog open={openViewDialog} onClose={handleCloseViewDialog} fullWidth maxWidth="sm">
        <DialogTitle>Speed Meeting Details</DialogTitle>

        <DialogContent>
          {speedMeetingToView && (
            <>
              <TextField
                fullWidth
                label="Subject"
                value={speedMeetingToView.subject || ""}
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />

              <TextField
                fullWidth
                label="Description"
                value={speedMeetingToView.description || ""}
                margin="normal"
                multiline
                rows={4}
                InputProps={{
                  readOnly: true,
                }}
              />

              <TextField
                fullWidth
                label="Contact"
                value={speedMeetingToView.contact || ""}
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />

              <TextField
                fullWidth
                label="State"
                value={
                  speedMeetingStates.find(
                    state => state.id === speedMeetingToView.speedmeeting_state_id
                  )?.state_name || ""
                }
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />

              <TextField
                fullWidth
                label="Start Date and Time"
                value={
                  new Date(speedMeetingToView.date).toLocaleString('pt-PT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'UTC'
                  })
                }
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />

              <TextField
                fullWidth
                label="End Date and Time"
                value={
                  speedMeetingToView.end_date
                    ? new Date(speedMeetingToView.end_date).toLocaleString('pt-PT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        timeZone: 'UTC'
                      })
                    : 'Not specified'
                }
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseViewDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

     <SpeedMeetingChatDialog
  open={openCommentsDialog}
  onClose={handleCloseCommentsDialog}
  meeting={speedMeetingForComments}
  userId={user?.userId}
  users={users}
  participants={
    invitedUsersMap[speedMeetingForComments?.id] || []
  }
  onMeetingUpdated={(updatedMeeting) => {
    setSpeedMeetings(prev =>
      prev.map(meeting =>
        meeting.id === updatedMeeting.id
          ? updatedMeeting
          : meeting
      )
    );

    setReceivedSpeedMeetings(prev =>
      prev.map(meeting =>
        meeting.id === updatedMeeting.id
          ? updatedMeeting
          : meeting
      )
    );
  }}
/>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Box>
        <Footer />
      </Box>
    </Box>
  );
}